export default "__VITE_ASSET__79cf3b31__"